import { Avatar } from '@mui/material';
import { OrgSupplier, OrgSupplierLite, PublicSupplier } from 'types/suppliers';
import { logoFromOrgSupplier } from 'utils/functions';
import { useTheme } from '@mui/material/styles';

const SupplierLogoAvatar = ({
  supplier,
  size = 36,
}: {
  supplier: OrgSupplier | PublicSupplier | OrgSupplierLite | null | undefined;
  size?: number;
}) => {
  const theme = useTheme();
  const logo = logoFromOrgSupplier(supplier);
  if (!supplier) return null;
  return (
    <Avatar
      variant="circular"
      src={logo}
      sx={{
        width: size,
        height: size,
        '& img': { objectFit: 'contain' },
        border: '1px solid',
        borderColor: theme.palette.grey[300],
      }}
    >
      {supplier?.name.slice(0, 2).toUpperCase()}
    </Avatar>
  );
};

export default SupplierLogoAvatar;
